
import { useCallback } from 'react';
import { useIsMobile } from './use-mobile';
import * as analytics from '@/utils/analytics';

export function useAnalytics() {
  const isMobile = useIsMobile();
  const deviceType = isMobile ? 'mobile' : 'desktop';
  
  const trackPageView = useCallback((path: string) => {
    analytics.trackPageView(path);
  }, []);
  
  const trackEvent = useCallback((
    category: string,
    action: string,
    label?: string,
    value?: number
  ) => {
    analytics.trackEvent(category, action, label, value);
  }, []);
  
  const trackTripCardAction = useCallback((
    actionType: Parameters<typeof analytics.trackTripCardAction>[0],
    tripId: string,
    destination: string
  ) => {
    analytics.trackTripCardAction(actionType, tripId, destination);
  }, []);
  
  const trackTimelineAction = useCallback((
    actionType: Parameters<typeof analytics.trackTimelineAction>[0],
    elementType: Parameters<typeof analytics.trackTimelineAction>[1],
    tripId: string,
    destination: string
  ) => {
    analytics.trackTimelineAction(actionType, elementType, tripId, destination);
  }, []);
  
  const trackIndexAction = useCallback((
    actionType: Parameters<typeof analytics.trackIndexAction>[0],
    tripId?: string,
    details?: string
  ) => {
    analytics.trackIndexAction(actionType, tripId, details);
  }, []);
  
  const trackError = useCallback((
    errorType: Parameters<typeof analytics.trackError>[0],
    errorMessage: string,
    componentName?: string
  ) => {
    analytics.trackError(errorType, errorMessage, componentName);
  }, []);
  
  const trackTripAdditionResult = useCallback((
    result: Parameters<typeof analytics.trackTripAdditionResult>[0],
    referenceOrName: string,
    details?: string
  ) => {
    analytics.trackTripAdditionResult(result, referenceOrName, details);
  }, []);
  
  return {
    deviceType,
    trackPageView,
    trackEvent,
    trackTripCardAction,
    trackTimelineAction,
    trackNavigation: analytics.trackNavigation,
    trackHeaderAction: analytics.trackHeaderAction,
    trackAuthAction: analytics.trackAuthAction,
    trackProfileAction: analytics.trackProfileAction,
    trackIndexAction,
    trackError,
    trackTripAdditionResult
  };
}
